import * as Yup from 'yup';
import 'yup-phone-lite';
import { LeadType } from '../../../models/dealer-prospect.model';

Yup.setLocale({
  mixed: {
    required: 'Required Field',
  },
});

export const DealerProspectSchema = Yup.object().shape({
  // Nothing is required on this form
  date: Yup.string().optional(),
  // division: Yup.string().optional().oneOf(Object.values(Division)),
  teamMemberName: Yup.string().optional().max(50),
  leadType: Yup.string().optional().oneOf(Object.values(LeadType)),
  leadTypeName: Yup.string().optional(),
  dealershipName: Yup.string().optional().max(100),
  contactFirstName: Yup.string().optional().max(50),
  contactLastName: Yup.string().optional().max(50),
  phone: Yup.string()
    .transform((v) => (v === '' ? undefined : v))
    .optional()
    .nullable()
    .phone('US', 'Please enter a valid phone number'),
  email: Yup.string()
    .transform((v) => (v === '' ? undefined : v))
    .optional()
    .nullable()
    .email('Please enter a valid email'),
  physicalAddress: Yup.object().shape({
    addressLine1: Yup.string().optional(),
    addressLine2: Yup.string().nullable().optional(),
    city: Yup.string().optional(),
    state: Yup.string().optional(),
    zipCode: Yup.string().optional(),
  }),
  notes: Yup.string().optional().max(20000),
});

export const dealerProspectInitialValues: any = {
  date: new Date().toISOString().split('T')[0],
  // division: Division.TSF,
  teamMemberName: '',
  leadType: LeadType.Event,
  leadTypeName: '',
  dealershipName: '',
  contactFirstName: '',
  contactLastName: '',
  phone: '',
  email: '',
  physicalAddress: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
  },
  notes: '',
};
